import { render } from "./FileMonitor.vue?vue&type=template&id=13a5b6cd"
import script from "./FileMonitor.vue?vue&type=script&lang=js"
export * from "./FileMonitor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__